import { Store } from 'redux';
import { DefaultSettings, settings } from '../../../settings/settings-util';
import { Message } from '../../../types/response';
import { AlmeState } from '../../../wireup/AlmeState';

export default class DateTimeOffset
{
    _settings: DefaultSettings;
    _store: Store<AlmeState> | null = null;
    
    constructor(passedSettings)
    {
        this._settings = passedSettings || settings;
    }

    static getDefaultSettings(): DefaultSettings
    {
        return settings;
    }

    initialize(store): void
    {
        this._store = store;
    }

    getRequestProcessor(): this
    {
        return this;
    }

    process(input): Message
    {
        let inputParameters = {};
        if (input.parameters)
        {
            inputParameters = input.parameters;
        }

        const offsetParamName = this._settings.time && this._settings.time.offsetParamName ? 
            this._settings.time.offsetParamName : "ClientTimeZoneOffset";

        const timeZoneNameParamName = this._settings.time && this._settings.time.timeZoneNameParamName ? 
            this._settings.time.timeZoneNameParamName : "ClientTimeZoneName";

        inputParameters[offsetParamName] = this.getClientOffset();
        inputParameters[timeZoneNameParamName] = this.getClientTimezoneName();

        return Object.assign({}, input, { parameters: inputParameters });
    }

    getClientOffset(): number
    {
        return new Date().getTimezoneOffset() / -60;
    }

    getClientTimezoneName(): string
    {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/request-processor-client-datetime-offset/src/request-processor-client-datetime-offset.ts